document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('koji-univ-search-input');
  const controlsWrap = document.querySelector('.koji-universi-controls');
  const filterContainer = document.getElementById('koji-univ-alpha-filter');
  const prevArrow = document.querySelector('.koji-arrow-prev');
  const nextArrow = document.querySelector('.koji-arrow-next');
  const alphaBtns = document.querySelectorAll('.koji-alpha-btn');
  const cards = document.querySelectorAll('.koji-univ-card');
  const emptyState = document.getElementById('koji-univ-empty-state');
  const gridContainer = document.getElementById('koji-universi-grid');

  // 0. ORDINAMENTO ALFABETICO DELLE CARD ALL'AVVIO
  if (gridContainer && cards.length > 0) {
    const cardsArray = Array.from(cards);
    cardsArray.sort((a, b) => {
      const titleA = a.getAttribute('data-title') || "";
      const titleB = b.getAttribute('data-title') || "";
      return titleA.localeCompare(titleB);
    });
    cardsArray.forEach(card => gridContainer.appendChild(card));
  }

  let currentSearchTerm = '';
  let currentAlphaFilter = 'all';

  function filterCards() {
    let visibleCount = 0;
    const sortedCards = document.querySelectorAll('.koji-univ-card');

    sortedCards.forEach(card => {
      const titleSearch = card.getAttribute('data-title') || "";
      const firstLetter = titleSearch.charAt(0).toLowerCase();
      
      const matchesSearch = titleSearch.includes(currentSearchTerm);
      
      let matchesAlpha = false;
      // ECCEZIONE RICERCA: Se stiamo scrivendo qualcosa, ignora il filtro alfabetico.
      if (currentSearchTerm.length > 0) {
        matchesAlpha = true;
      } else if (currentAlphaFilter === 'all') {
        matchesAlpha = true;
      } else if (currentAlphaFilter === '#') {
        matchesAlpha = /^[0-9]/.test(firstLetter);
      } else {
        matchesAlpha = firstLetter === currentAlphaFilter;
      }

      if (matchesSearch && matchesAlpha) {
        card.style.display = 'block'; 
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    if (visibleCount === 0) {
      gridContainer.style.display = 'none';
      emptyState.style.display = 'block';
    } else {
      gridContainer.style.display = 'grid';
      emptyState.style.display = 'none';
    }
  }

  // 1. GESTIONE RICERCA E ANIMAZIONE BARRA
  if (searchInput && controlsWrap) {
    searchInput.addEventListener('input', function(e) {
      currentSearchTerm = e.target.value.toLowerCase().trim();
      if (currentSearchTerm.length > 0) {
        controlsWrap.classList.add('is-searching');
      } else {
        controlsWrap.classList.remove('is-searching');
      }
      filterCards();
    });
  }

  // 2. GESTIONE SCROLL FRECCE ALFABETO (Desktop)
  if (prevArrow && nextArrow && filterContainer) {
    prevArrow.addEventListener('click', () => {
      filterContainer.scrollBy({ left: -250, behavior: 'smooth' });
    });
    nextArrow.addEventListener('click', () => {
      filterContainer.scrollBy({ left: 250, behavior: 'smooth' });
    });
  }

  // 3. GESTIONE BOTTONI ALFABETO
  if (alphaBtns.length > 0) {
    alphaBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        alphaBtns.forEach(b => b.classList.remove('is-active'));
        this.classList.add('is-active');
        currentAlphaFilter = this.getAttribute('data-letter');
        filterCards();
      });
    });
  }

  // 4. GESTIONE FLIP CARD E POPUP 
  const infoBtns = document.querySelectorAll('.koji-univ-info-btn');
  const closeFlipBtns = document.querySelectorAll('.koji-univ-close-flip');
  const popupOverlay = document.getElementById('koji-univ-popup');
  const popupCloseBtn = document.getElementById('koji-univ-popup-close');
  const popupLinkBtn = document.getElementById('koji-univ-popup-link');

  infoBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const card = this.closest('.koji-univ-card');

      if (window.innerWidth >= 990) {
        card.classList.toggle('is-flipped');
      } else {
        const originalTitle = card.getAttribute('data-original-title');
        const desc = card.getAttribute('data-desc');
        const cardFrontLink = card.querySelector('.koji-univ-card-front');
        const url = cardFrontLink ? cardFrontLink.getAttribute('href') : '#';

        document.getElementById('koji-univ-popup-title').textContent = originalTitle;
        document.getElementById('koji-univ-popup-desc').textContent = desc;
        if(popupLinkBtn) popupLinkBtn.href = url;
        
        popupOverlay.classList.add('is-active');
      }
    });
  });

  closeFlipBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.closest('.koji-univ-card').classList.remove('is-flipped');
    });
  });

  if (popupOverlay && popupCloseBtn) {
    popupCloseBtn.addEventListener('click', () => {
      popupOverlay.classList.remove('is-active');
    });
    
    popupOverlay.addEventListener('click', (e) => {
      if (e.target === popupOverlay) {
        popupOverlay.classList.remove('is-active');
      }
    });
  }

  // 5. GESTIONE TOOLTIP MOBILE (BADGE QUANTITÀ)
  const countBadges = document.querySelectorAll('.koji-univ-count-badge');
  countBadges.forEach(badge => {
    badge.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const wasActive = this.classList.contains('is-active');
      
      // Chiudi tutti gli altri tooltip aperti
      countBadges.forEach(b => b.classList.remove('is-active'));
      
      // Se non era attivo, attivalo
      if (!wasActive) {
        this.classList.add('is-active');
      }
    });
  });

  // Chiudi il tooltip se si clicca in qualsiasi altro punto della pagina
  document.addEventListener('click', () => {
    countBadges.forEach(b => b.classList.remove('is-active'));
  });
});